import { render, staticRenderFns } from "./EditSalesForceLookup.vue?vue&type=template&id=5bcf2689&scoped=true&"
import script from "./EditSalesForceLookup.vue?vue&type=script&lang=js&"
export * from "./EditSalesForceLookup.vue?vue&type=script&lang=js&"
import style0 from "./EditSalesForceLookup.vue?vue&type=style&index=0&id=5bcf2689&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcf2689",
  null
  
)

export default component.exports